import React from "react";
import { FiPlus } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

const NotetypeHeader = ({ permission }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  return (
    <>
      <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
        {permission?.pf_add === 1 && (
          <Link
            to={`/master/add-note-type?id=${M_id}`}
            className="btn btn-primary"
          >
            <FiPlus size={16} className="me-2" />
            <span>Create Note type</span>
          </Link>
        )}
      </div>
    </>
  );
};

export default NotetypeHeader;
